<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="refresh 1">
      <path
        id="Vector"
        d="M11.766 4.23464C10.7993 3.26797 9.47268 2.66797 7.99935 2.66797C6.58486 2.66797 5.22831 3.22987 4.22811 4.23007C3.22792 5.23026 2.66602 6.58681 2.66602 8.0013C2.66602 9.41579 3.22792 10.7723 4.22811 11.7725C5.22831 12.7727 6.58486 13.3346 7.99935 13.3346C10.486 13.3346 12.5593 11.6346 13.1527 9.33463H11.766C11.2193 10.888 9.73935 12.0013 7.99935 12.0013C6.93848 12.0013 5.92107 11.5799 5.17092 10.8297C4.42078 10.0796 3.99935 9.06217 3.99935 8.0013C3.99935 6.94044 4.42078 5.92302 5.17092 5.17287C5.92107 4.42273 6.93848 4.0013 7.99935 4.0013C9.10602 4.0013 10.0927 4.4613 10.8127 5.18797L8.66602 7.33464H13.3327V2.66797L11.766 4.23464Z"
        :fill="color" />
    </g>
  </svg>
</template>

<script>
  export default {
    name: "CogIcon",
    props: {
      color: {
        type: String,
        default: "#6A49EF",
      },
    },
  };
</script>
